if (!customElements.get('crosssell-combo')) {
  customElements.define('crosssell-combo', class extends HTMLElement {
    constructor() {
      super();
      this.triggers = this.querySelectorAll('[data-crosssell-combo-trigger]');
      this.modals = this.querySelectorAll('[data-crosssell-combo-modal]');
    }

    connectedCallback() {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', this.openModal.bind(this));
      });

      this.modals.forEach(modal => {
        modal.querySelectorAll('[data-crosssell-combo-close]').forEach(btn => {
          btn.addEventListener('click', () => this.closeModal(modal));
        });

        modal.addEventListener('cancel', (e) => {
          e.preventDefault();
          this.closeModal(modal);
        });

        const atcBtn = modal.querySelector('[data-crosssell-combo-atc]');
        if (atcBtn) {
          atcBtn.addEventListener('click', (e) => this.addBothToCart(e));
        }
      });
    }

    openModal(e) {
      const comboId = e.currentTarget.getAttribute('data-crosssell-combo-trigger');
      const modal = this.querySelector(`[data-crosssell-combo-modal="${comboId}"]`);
      if (!modal) return;

      modal.removeAttribute('inert');
      modal.showModal();
      modal.classList.add('is-open');
      document.documentElement.classList.add('crosssell-modal-open');
    }

    closeModal(modal) {
      if (!modal.open) return;

      modal.classList.remove('is-open');
      modal.classList.add('is-closing');

      const onEnd = () => {
        modal.close();
        modal.setAttribute('inert', '');
        modal.classList.remove('is-closing');
        document.documentElement.classList.remove('crosssell-modal-open');
        modal.removeEventListener('animationend', onEnd);
        clearTimeout(fallback);
      };

      modal.addEventListener('animationend', onEnd, { once: true });
      const fallback = setTimeout(onEnd, 400);
    }

    async addBothToCart(e) {
      const btn = e.currentTarget;
      if (btn.disabled || btn.classList.contains('is-loading')) return;

      const variantIds = JSON.parse(btn.getAttribute('data-variant-ids'));
      if (!variantIds || variantIds.length < 2) return;

      btn.classList.add('is-loading');
      btn.disabled = true;

      const items = variantIds.map(id => ({ id: id, quantity: 1 }));

      try {
        const response = await fetch(window.theme?.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
          },
          body: JSON.stringify({ items: items }),
        });

        const data = await response.json();

        if (data.status) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          console.error('Add to cart error:', data.description);
          return;
        }

        btn.classList.remove('is-loading');
        btn.classList.add('is-added');

        const modal = btn.closest('[data-crosssell-combo-modal]');

        setTimeout(() => {
          btn.classList.remove('is-added');
          btn.disabled = false;
          if (modal) this.closeModal(modal);
        }, 600);

        // Trigger theme's cart refresh + drawer open (same flow as native add-to-cart)
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
          } else if (window.theme?.routes?.cart_url) {
            window.location = window.theme.routes.cart_url;
          }
        }, 700);

      } catch (error) {
        console.error('Add to cart error:', error);
        btn.classList.remove('is-loading');
        btn.disabled = false;
      }
    }
  });
}
